var map = {
	"./ar/data.json": [
		96959,
		6959
	],
	"./cs/data.json": [
		5636,
		5636
	],
	"./de/data.json": [
		28887,
		8887
	],
	"./en/data.json": [
		12719
	],
	"./es/data.json": [
		52750,
		2750
	],
	"./fa/data.json": [
		65561,
		5561
	],
	"./fi/data.json": [
		24177,
		4177
	],
	"./fr/data.json": [
		93494,
		3494
	],
	"./he/data.json": [
		33835,
		3835
	],
	"./id/data.json": [
		44481,
		4481
	],
	"./it/data.json": [
		44177,
		6558
	],
	"./ja/data.json": [
		16261,
		6261
	],
	"./kk/data.json": [
		52004,
		2004
	],
	"./ko/data.json": [
		98464,
		8464
	],
	"./ms/data.json": [
		91670,
		1670
	],
	"./nl/data.json": [
		3328,
		3328
	],
	"./pl/data.json": [
		55454,
		5454
	],
	"./pt-BR/data.json": [
		18289,
		8289
	],
	"./pt/data.json": [
		83158,
		3158
	],
	"./ru/data.json": [
		51617,
		1617
	],
	"./sk/data.json": [
		46940,
		6940
	],
	"./sv/data.json": [
		68885,
		8885
	],
	"./tr/data.json": [
		79036,
		9036
	],
	"./uk/data.json": [
		46358,
		6358
	],
	"./vi/data.json": [
		5793,
		5793
	],
	"./zh/data.json": [
		64904,
		4904
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 78663;
module.exports = webpackAsyncContext;